// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderSubtitle_wrapper_WzPz9"};